import { type ComponentPropsWithoutRef } from "react";
import { Component } from "./styles";
import classNames from "classnames";

export interface PopupBodyProps extends ComponentPropsWithoutRef<"div"> {
  screen?: boolean;
}

export function PopupBody(props: PopupBodyProps) {
  return (
    <Component
      className={classNames({
        screen: props.screen,
      })}
      {...props}
    />
  );
}
